import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MalihuScrollbarService } from 'ngx-malihu-scrollbar';

@Component({
  selector: 'app-notification-view',
  templateUrl: './notification-view.component.html',
  styleUrls: ['./notification-view.component.css']
})
export class NotificationViewComponent implements OnInit {

  @Input() notifications: any[] = [];
  @Input() count: number = 0;
  @Input() extraClass = ''

  @Output() onNotificationClick = new EventEmitter();
  @Output() onNotificationScrolled = new EventEmitter();

  public scrollbarOptions = {
    axis: 'y',
    theme: 'minimal',
    autoExpandScrollbar: true,
    // scrollbarPosition: 'outside',
    scrollInertia: 200,
    mouseWheel: { preventDefault: true },
    callbacks: {
      onTotalScrollOffset: 30,
      onTotalScroll: () => {
        this.onNotificationScrolled.emit()
      }
    }
  };

  constructor() { }

  ngOnInit() {
  }

  onClick(notification) {
    this.onNotificationClick.emit(notification);
  }

}



// WEBPACK FOOTER //
// G:/UTL/Student/Student-ANG/src/app/shared/notification-view/notification-view.component.ts